<template>
  <div class="modal custom-fade fade" id="view_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div class="form-header modal-header-title text-start mb-0">
            <h4 class="mb-0">Expense Details</h4>
          </div>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span class="align-center" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <a v-if="expense?.attachment" :href="expense?.attachment" target="_blank">
              <div>
                <img
                  class="avatar-img rounded"
                  height="30"
                  :src="expense?.attachment"
                  alt="User Image"
                />
              </div>
            </a>
            <div class="col-6">
              <p class="text-black fw-semibold mt-4">
                Customer :
                <span class="text-secondary fw-normal">{{
                  expense?.customer?.name || "N/A"
                }}</span>
              </p>
              <p class="text-black fw-semibold mt-3">
                Recurring :
                <span class="text-secondary fw-normal">{{
                  expense?.recurring ? "Yes" : "No" || "N/A"
                }}</span>
              </p>
              <p v-if="expense?.recurring" class="text-black fw-semibold mt-3">
                Recurring Mode :
                <span class="text-secondary fw-normal text-capitalize">{{
                  expense?.recurring_duration?.mode || "N/A"
                }}</span>
              </p>
              <p class="text-black fw-semibold mt-3">
                Date :
                <span class="text-secondary fw-normal">{{
                  formatted(expense?.date) || "N/A"
                }}</span>
              </p>
              <p class="text-black fw-semibold mt-3">
                Notes :
                <span class="text-secondary fw-normal">{{
                  expense?.notes || "N/A"
                }}</span>
              </p>
            </div>
            <!-- Second Section -->
            <div class="col-6">
              <p class="text-black fw-semibold mt-4">
                Amount :
                <span class="text-secondary fw-normal"
                  >{{ expense?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(expense?.amount) || "N/A" }}</span
                >
              </p>
              <p class="text-black fw-semibold mt-3">
                Status :
                <span
                  class="badge bg-warning-light text-capitalize"
                  v-if="
                    expense?.status === 'pending' || expense?.status === 'draft'
                  "
                  ><span
                    class="text-warning-light fw-normal"
                    style="font-size: 13px"
                    >{{ expense?.status || "N/A" }}</span
                  ></span
                >
                <span
                  class="badge bg-success-light text-success-light text-capitalize"
                  v-if="
                    expense?.status === 'paid' ||
                    expense?.status === 'refunded' ||
                    expense?.status === 'sent' ||
                    expense?.status === 'viewed' ||
                    expense?.status === 'accepted'
                  "
                  ><span
                    class="text-success-light fw-normal"
                    style="font-size: 13px"
                    >{{ expense?.status || "N/A" }}</span
                  ></span
                >
                <span
                  class="badge bg-warning-light text-capitalize"
                  v-if="expense?.status === 'reoccurring'"
                  ><span
                    class="text-warning-light fw-normal"
                    style="font-size: 13px"
                    >{{ expense?.status || "N/A" }}</span
                  ></span
                >
                <span
                  class="badge bg-warning-light text-warning-light text-capitalize"
                  v-else-if="expense?.status === 'partially_paid'"
                  >Partially paid</span
                >
                <span
                  class="badge bg-danger-light text-capitalize"
                  v-else-if="
                    expense?.status === 'expired' ||
                    expense?.status === 'rejected' ||
                    expense?.status === 'overdue'
                  "
                  ><span
                    class="text-danger-light fw-normal"
                    style="font-size: 13px"
                    >{{ expense?.status || "N/A" }}</span
                  ></span
                >
              </p>
              <p v-if="expense?.recurring" class="text-black fw-semibold mt-3">
                Recurring Value :
                <span class="text-secondary fw-normal">{{
                  expense?.recurring_duration?.value || "N/A"
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatted } from "@/assets/composables/date";
import { addCurrencyComma } from "@/assets/composables/currency";

const props = defineProps({
  expense: {
    type: Object,
  },
});
</script>
